"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["title"];

function SvgCalendar(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    $_css: props.color,
    $_css2: props.size,
    $_css3: props.size,
    $_css4: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6 4.4V2H14v4h-.8V4.4H7.6V2H6v4h-.8V4.4H3.6C2.718 4.4 2 5.118 2 6v10.4c0 .882.718 1.6 1.6 1.6h12.8c.882 0 1.6-.718 1.6-1.6V6c0-.882-.718-1.6-1.6-1.6h-.8zm-12 12V7.6h12.8l-.002 8.8H3.6zm8.838-7.314v.8c0 .226-.025.409-.074.548-.05.14-.097.259-.142.357l-1.695 3.647a1.174 1.174 0 01-.364.447c-.16.121-.372.182-.636.182H8.133l1.763-3.432c.086-.176.18-.334.28-.474.101-.14.212-.273.33-.4h-2.36a.402.402 0 01-.163-.034.442.442 0 01-.136-.093.49.49 0 01-.096-.135.358.358 0 01-.037-.157V9.086h4.724z",
    fill: "currentColor"
  }));
}

var _default = SvgCalendar;
exports["default"] = _default;

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "Calendar___StyledSvg",
  componentId: "sc-1m7zsnl-0"
})(["color:", ";width:", ";height:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
}, function (p) {
  return p.$_css4;
});
//# sourceMappingURL=Calendar.js.map